import {
  CopyOutlined,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Flex, Input, Spin } from "antd";
import useMessage from "antd/es/message/useMessage";
import { useState } from "react";
import { fileInput } from "../components/common";
import { call, downloadCall, uploadCall } from "../tsrpc";

export default function PageAssetBundle() {
  const [remote] = useState('http://xahz.tech/remote');
  const [message, messageContext] = useMessage();
  const [spin, setSpin] = useState({ spinning: false, tip: "" });

  return (
    <>
      <Flex
        vertical
        gap={10}
        justify="center"
        align="center"
        style={{ height: "100%", margin: "auto" }}
      >
        <Input
          readOnly
          style={{ width: "min(500px, calc(100vw - 32px))" }}
          value={remote}
          addonBefore="远程地址"
          addonAfter={
            <Button
              icon={<CopyOutlined />}
              color="primary"
              variant="link"
              size="small"
              onClick={() => {
                const input = document.createElement("input");
                input.value = remote;
                document.body.appendChild(input);
                input.select();
                document.execCommand("copy");
                document.body.removeChild(input);
                message.success("远程地址已复制到粘贴板");
              }}
            >
              复制
            </Button>
          }
        />
        <Button
          block
          size="large"
          icon={<DownloadOutlined />}
          style={{ width: "min(300px, calc(100vw - 32px))" }}
          onClick={async () => {
            setSpin({ spinning: true, tip: "等待服务器准备资源包..." });
            await downloadCall("images");
            setSpin({ spinning: false, tip: "" });
          }}
        >
          下载图片资源包
        </Button>
        <Button
          block
          size="large"
          icon={<UploadOutlined />}
          style={{ width: "min(300px, calc(100vw - 32px))" }}
          onClick={async () => {
            setSpin({ spinning: true, tip: "正在上传文件..." });
            const files = await fileInput({ accept: ".zip", multiple: false });
            const res = await uploadCall(".", files[0]);
            if (!res.isSucc) return;
            call(
              'editor/UploadAssetBundle',
              {
                timestamp: Date.now(),
                token: localStorage.getItem("token")!,
                name: res.res.md5,
              },
              { timeout: 60000 }
            ).then(() => setSpin({ spinning: false, tip: "" }));
          }}
        >
          上传 Asset Bundle
        </Button>
      </Flex>
      <Spin fullscreen {...spin} />
      {messageContext}
    </>
  );
}
